import React from 'react';
import { StyleSheet, Text, View } from 'react-native';

import { fonts } from '../Styles';
import { history } from '../util/History';
import { MNOHSButton } from './MNOHSButton';
import { MNOHSDashboardWrapper } from './MNOHSDashboardWrapper';

export const MNOHS404: React.FC<{}> = props => {
  return (
    <MNOHSDashboardWrapper headerTitle={''} headerShown={false} padded={true}>
      <View style={styles.container}>
        <Text style={styles.title}>Oops!</Text>
        <Text style={styles.subtitle}>We can't find the page you're looking for.</Text>
        <MNOHSButton title={'Take me home'} onPress={() => history.push('/')} style={_styles.button} />
      </View>
    </MNOHSDashboardWrapper>
  );
};

const _styles = {
  button: { marginTop: 48, width: '50%' },
};

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    marginTop: '25vh',
  },
  title: {
    ...fonts.header1,
    fontSize: 48,
  },
  subtitle: {
    ...fonts.paragraph,
    marginVertical: 8,
  },
});
